import { render } from "./GoldLifetimeBirthday.vue?vue&type=template&id=459cda36&scoped=true"
import script from "./GoldLifetimeBirthday.vue?vue&type=script&lang=js"
export * from "./GoldLifetimeBirthday.vue?vue&type=script&lang=js"

import "./GoldLifetimeBirthday.vue?vue&type=style&index=0&id=459cda36&scoped=true&lang=css"

import exportComponent from "S:\\_Projects\\TRC4\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_5cff2737dde116e8fc1156af408c1302\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459cda36"]])

export default __exports__